import { render, staticRenderFns } from "./RegistroFolios.vue?vue&type=template&id=621fbcae&"
import script from "./RegistroFolios.vue?vue&type=script&lang=js&"
export * from "./RegistroFolios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports